import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MagentoEcommerceDevelopersInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Magento E-commerce Developers in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Expert Magento Solutions</Subheading>}
        heading={
          <Heading>
            Magento <span tw="text-primary-500">E-commerce Developers</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset offers expert Magento e-commerce development in **Al
            Barsha**, delivering powerful, scalable, and customized online
            stores. Our certified developers ensure your business thrives with
            Magento’s robust platform.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Magento Development"
        description="We craft high-performance Magento stores tailored to your needs."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Custom Magento Stores",
            description: "Unique solutions for your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Performance",
            description: "Handle millions of SKUs with ease.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Seamless Integrations",
            description: "Connect with ERP, CRM, and more.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Robust Security",
            description: "Protect your store and customers.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Responsive",
            description: "Optimized for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in Al Barsha",
            description: "Local expertise, global standards.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Deliver</Subheading>}
        heading="Our Magento Development Process"
        description={
          <Description>
            We build your Magento store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Analyze your business needs.</li>
              <li>Design: Create intuitive, engaging interfaces.</li>
              <li>Development: Implement custom modules and integrations.</li>
              <li>Testing: Ensure flawless performance and security.</li>
              <li>Launch: Deploy your store efficiently.</li>
              <li>Support: Offer ongoing maintenance and upgrades.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Magento Success in Al Barsha"
        description="Our stores drive measurable results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "Increased revenue by 150% in 3 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Deployment",
            description: "Launched stores in under 7 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% positive feedback rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Scale?</Subheading>}
        heading="Magento E-commerce Developers in Al Barsha"
        description={
          <Description>
            MilaajBrandset’s Magento e-commerce developers in Al Barsha deliver
            powerful, secure, and scalable online stores. Contact us to
            transform your business today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
